<template>
  <div @mouseover="setButtonHover(true)" @mouseleave="setButtonHover(false)">
    <v-menu v-model="open" :right="!isPhoneBool" :top="isPhoneBool" :offset-y="true" :offset-x="true" class="top"
      :open-on-hover="tmpbuttonhover || buttonhover || menuhover">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" v-text="'mdi-dots-vertical'" :color="buttonclicked ? 'tertiary' : (tmpbuttonhover ? 'primary' : '')" @click.stop="setButtonClicked(true)">
        </v-icon>
      </template>
      <v-card flat @mouseover="setMenuHover(true)" @mouseleave="setMenuHover(false)">
        <v-list class="pa-0">
          <slot name="content">
            <v-hover v-for="action in actionList" :key="action.title" v-slot="{ hover }">
              <v-list-item @click="parentcontext[action.method]()" :disabled="action.disabled">
                <v-list-item-content class="pa-0 ma-0">
                  <v-list-item-title v-text="action.title"
                    :class="(hover ? (action.hovercolor ? action.hovercolor : 'black') : '#5f5f5f') + '--text'">
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-text="action.icon" :color="hover ? (action.hovercolor ? action.hovercolor : 'black') : null"
                    :size="action.iconsize ? action.iconsize : 22" />
                </v-list-item-action>
              </v-list-item>
            </v-hover>
          </slot>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "ActionMenu",
  props: ["parentcontext", "actionList"],
  components: {},

  data() {
    return {
      tmpbuttonhover: false,
      buttonhover: false,
      menuhover: false,
      buttonclicked: false,
    };
  },

  methods: {
    setButtonClicked(val) {
      this.buttonclicked = val;
    },
    setButtonHover(val) {
      this.tmpbuttonhover = val;
      setTimeout(() => {
        this.buttonhover = this.tmpbuttonhover;
      }, 400);
    },
    setMenuHover(val) {
      this.menuhover = val;
    },
  },

  computed: {
    open: {
      get() {

        return this.menuhover || this.buttonhover || this.buttonclicked;
      },
      set(val) {
        this.buttonclicked = val
      }
    }
  },

  watch: {},
};
</script>

<style>
.top {
  z-index: 1000000;
}

.v-list-item__action,
.v-list-item__avatar,
.v-list-item__icon {
  justify-content: center;
}
</style>